import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AuthenticationService, CartService, ConfigurationService, PathsService } from '@draeger-academy/common';
import { User } from 'models/user';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

@Component({
    selector: 'da-checkout',
    templateUrl: './checkout.component.html',
    styleUrls: ['./checkout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckoutComponent implements OnInit, OnDestroy {
    loading = false;
    submitted = false;
    remember: boolean = false;
    isEmpty: boolean = true;
    isLoggedIn: boolean;
    coursesLink: string;
    public _$showLogin: BehaviorSubject<boolean> = new BehaviorSubject(false);
    user: User = {
        id: 0,
        username: '',
        password: '',
        token: ''
    };
    @Input() showLogin: boolean = true;
    @Output()
    nextStep: EventEmitter<string> = new EventEmitter<string>();
    public _$itemsNumber: BehaviorSubject<Number> = new BehaviorSubject(0);
    private _subscriptionLoggedIn: Subscription;
    private _subscriptionItemsNumber: Subscription;

    constructor(
        private authenticationService: AuthenticationService,
        public cartService: CartService,
        private _configurationService: ConfigurationService,
        private _pathsService: PathsService
    ) {
        this.cartService.itemsNumber().subscribe((itemsNumber) => {
            this._$itemsNumber.next(itemsNumber);
        });
    }

    public get showLogin$(): Observable<boolean> {
        return this._$showLogin.asObservable();
    }

    public get itemsNumber$(): Observable<Number> {
        return this._$itemsNumber.asObservable();
    }

    ngOnInit() {
        this.coursesLink = this._pathsService.getCourseListLink();
        this._subscriptionItemsNumber = this.cartService.itemsNumber().subscribe((itemsNumber) => {
            this._$itemsNumber.next(itemsNumber);
            if (itemsNumber !== 0) {
                this.isEmpty = false;
            }
        });
        localStorage.removeItem('sameBillingLikeBooking');
    }

    ngOnDestroy() {
        if (this._subscriptionItemsNumber) {
            this._subscriptionItemsNumber.unsubscribe();
        }
        if (this._subscriptionLoggedIn) {
            this._subscriptionLoggedIn.unsubscribe();
        }
    }

    next(number) {
        this.nextStep.emit(number);
    }
}
